import { AGG } from './types';

export const tlp = {
  id: 'tlp',
  label: 'TLP',
  description: 'Report multi-canale con breakdown per tipo di creatività. Include Spotify.',
  single_image: true,
  sections: [
    {
      id: 'meta',
      title: 'Meta',
      blocks: [
        {
          channel: 'meta',
          label: 'Panoramica',
          kpis: [
            { key: 'date_start', label: 'Data di inizio', aggregation: AGG.AUTO_MIN },
            { key: 'date_end',   label: 'Data di fine',   aggregation: AGG.AUTO_MAX },
            { key: 'spend',      label: 'Importo speso',  aggregation: AGG.SUM, unit: 'currency' },
          ],
        },
        {
          channel: 'meta',
          label: 'Carosello con prodotti',
          adset_filter: 'carosello',
          kpis: [
            { key: 'reach',       label: 'Reach',             aggregation: AGG.DISTINCT, note: 'Awareness + Traffico, ogni campagna distinta' },
            { key: 'impressions', label: 'Impression',         aggregation: AGG.SUM },
            { key: 'cpm',         label: 'CPM',                aggregation: AGG.DISTINCT, unit: 'currency', note: 'Ogni campagna distinta' },
            { key: 'engagement',  label: 'Engagement',         aggregation: AGG.SUM },
            { key: 'link_clicks', label: 'Click su link',      aggregation: AGG.SUM },
            { key: 'cpc',         label: 'CPC click su link',  aggregation: AGG.SUM, unit: 'currency' },
          ],
        },
        {
          channel: 'meta',
          label: 'Video Creator',
          adset_filter: 'video creator',
          kpis: [
            { key: 'reach',       label: 'Reach',             aggregation: AGG.DISTINCT, note: 'Campagna con influencer, ogni campagna distinta' },
            { key: 'impressions', label: 'Impression',         aggregation: AGG.SUM },
            { key: 'cpm',         label: 'CPM',                aggregation: AGG.DISTINCT, unit: 'currency', note: 'Ogni campagna distinta' },
            { key: 'engagement',  label: 'Engagement',         aggregation: AGG.SUM },
            { key: 'link_clicks', label: 'Click su link',      aggregation: AGG.SUM },
            { key: 'cpc',         label: 'CPC click su link',  aggregation: AGG.SUM, unit: 'currency' },
            { key: 'video_views', label: 'Video Views',        aggregation: AGG.SUM },
          ],
        },
        {
          channel: 'meta',
          label: 'Contenuto in-store',
          adset_filter: 'instore',
          kpis: [
            { key: 'reach',       label: 'Reach',             aggregation: AGG.DISTINCT, note: 'Ogni campagna distinta' },
            { key: 'impressions', label: 'Impression',         aggregation: AGG.SUM },
            { key: 'cpm',         label: 'CPM',                aggregation: AGG.DISTINCT, unit: 'currency', note: 'Ogni campagna distinta' },
            { key: 'engagement',  label: 'Engagement',         aggregation: AGG.SUM },
            { key: 'link_clicks', label: 'Click su link',      aggregation: AGG.SUM },
            { key: 'cpc',         label: 'CPC click su link',  aggregation: AGG.SUM, unit: 'currency' },
          ],
        },
      ],
    },
    {
      id: 'google',
      title: 'Google',
      blocks: [
        {
          channel: 'google',
          kpis: [
            { key: 'date_start',  label: 'Data di inizio', aggregation: AGG.AUTO_MIN },
            { key: 'date_end',    label: 'Data di fine',   aggregation: AGG.AUTO_MAX },
            { key: 'spend',       label: 'Importo speso',  aggregation: AGG.SUM, unit: 'currency' },
            { key: 'impressions', label: 'Impression',     aggregation: AGG.SUM },
            { key: 'cpm',         label: 'CPM',            aggregation: AGG.SUM, unit: 'currency' },
            { key: 'link_clicks', label: 'Click sul link', aggregation: AGG.SUM },
            { key: 'cpc',         label: 'CPC',            aggregation: AGG.SUM, unit: 'currency' },
          ],
        },
      ],
    },
    {
      id: 'youtube',
      title: 'YouTube',
      blocks: [
        {
          channel: 'youtube',
          kpis: [
            { key: 'date_start',  label: 'Data di inizio',     aggregation: AGG.AUTO_MIN },
            { key: 'date_end',    label: 'Data di fine',       aggregation: AGG.AUTO_MAX },
            { key: 'spend',       label: 'Importo speso',      aggregation: AGG.SUM, unit: 'currency' },
            { key: 'impressions', label: 'Impression',         aggregation: AGG.SUM },
            { key: 'cpm',         label: 'CPM',                aggregation: AGG.SUM, unit: 'currency' },
            { key: 'video_views', label: 'Riproduzione video', aggregation: AGG.SUM },
            { key: 'link_clicks', label: 'Click sul link',     aggregation: AGG.SUM },
          ],
        },
      ],
    },
    {
      id: 'tiktok',
      title: 'TikTok',
      blocks: [
        {
          channel: 'tiktok',
          label: 'Contenuto Gallicantus instore',
          adset_filter: 'gallicantus instore',
          kpis: [
            { key: 'date_start',  label: 'Data di inizio',    aggregation: AGG.AUTO_MIN },
            { key: 'date_end',    label: 'Data di fine',      aggregation: AGG.AUTO_MAX },
            { key: 'reach',       label: 'Reach',             aggregation: AGG.DISTINCT, note: 'Ogni campagna distinta' },
            { key: 'impressions', label: 'Impression',        aggregation: AGG.SUM },
            { key: 'cpm',         label: 'CPM',               aggregation: AGG.DISTINCT, unit: 'currency', note: 'Ogni campagna distinta' },
            { key: 'engagement',  label: 'Engagement',        aggregation: AGG.SUM },
            { key: 'link_clicks', label: 'Click su link',     aggregation: AGG.SUM },
            { key: 'cpc',         label: 'CPC click su link', aggregation: AGG.SUM, unit: 'currency' },
          ],
        },
        {
          channel: 'tiktok',
          label: 'Video Creator',
          adset_filter: 'video creator',
          kpis: [
            { key: 'reach',       label: 'Reach',             aggregation: AGG.DISTINCT, note: 'Ogni campagna distinta' },
            { key: 'impressions', label: 'Impression',        aggregation: AGG.SUM },
            { key: 'cpm',         label: 'CPM',               aggregation: AGG.DISTINCT, unit: 'currency', note: 'Ogni campagna distinta' },
            { key: 'engagement',  label: 'Engagement',        aggregation: AGG.SUM },
            { key: 'link_clicks', label: 'Click su link',     aggregation: AGG.SUM },
            { key: 'cpc',         label: 'CPC click su link', aggregation: AGG.SUM, unit: 'currency' },
          ],
        },
      ],
    },
    {
      id: 'spotify',
      title: 'Spotify',
      blocks: [
        {
          channel: 'spotify',
          kpis: [
            { key: 'date_start',            label: 'Data di inizio',     aggregation: AGG.AUTO_MIN },
            { key: 'date_end',              label: 'Data di fine',       aggregation: AGG.AUTO_MAX },
            { key: 'reach',                 label: 'Reach',              aggregation: AGG.SUM },
            { key: 'impressions',           label: 'Impression',         aggregation: AGG.SUM },
            { key: 'link_clicks',           label: 'Click',              aggregation: AGG.SUM },
            { key: 'video_completion_rate', label: '% di completamento', aggregation: AGG.SUM, unit: 'percent' },
          ],
        },
      ],
    },
  ],
};
